<router-outlet></router-outlet>
<app-toast></app-toast>
<app-loading-spinner></app-loading-spinner>
<app-session-manager></app-session-manager>